// iceServers.js
export const ICE_TIERS = [
  {
    name: "primary",
    iceServers: [
      { urls: "stun:stun.pickitforme.com" },
    ],
  },
  {
    name: "turn-udp",
    iceServers: [
      {
        urls: "turn:turn.pickitforme.com?transport=udp",
        username: "user1",
        credential: "password1",
      },
    ],
  },
  {
    name: "turn-tcp",
    iceServers: [
      {
        urls: "turn:turn.pickitforme.com?transport=tcp",
        username: "user1",
        credential: "password1",
      },
    ],
  },
];
